import { Record, Set } from 'immutable'

import {
  SET_ACTIVE_NOTE_ID,
  TOGGLE_EXPAND_NOTE,
  EXPAND_NOTE,
  EXPAND_NOTES,
} from './actionTypes'

const InitialState = Record(
  {
    activeNoteId: null,
    expandedNoteIds: Set(),
  },
  'publicUI'
)

const uiReducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case SET_ACTIVE_NOTE_ID: {
      const { id } = action.payload
      if (id === state.get('activeNoteId')) {
        return state
      }
      return state.set('activeNoteId', id)
    }
    case TOGGLE_EXPAND_NOTE: {
      const { noteId } = action.payload
      const isOpen = state.get('expandedNoteIds').has(noteId)
      return state.update(
        'expandedNoteIds',
        idSet => (isOpen ? idSet.remove(noteId) : idSet.add(noteId))
      )
    }
    case EXPAND_NOTE: {
      const { noteId } = action.payload
      return state.update('expandedNoteIds', idSet => idSet.add(noteId))
    }
    case EXPAND_NOTES: {
      const { noteIds } = action.payload
      return state.update('expandedNoteIds', idSet => idSet.concat(noteIds))
    }
    default: {
      return state
    }
  }
}

export default uiReducer
